module.exports = {
  "country": "ES",
  "artist": "Mocedades",
  "song": "Eres Tú",
  "year": "1973",
  "place": "2",
  "spotify": "5MWUstMMH2rcxqTSkEeTtP"
};